import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Menu, Popover, Transition } from '@headlessui/react'
import moment from 'moment'
import {
  AcademicCapIcon,
  BanknotesIcon,
  Bars3Icon,
  BellIcon,
  CheckBadgeIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,
  XMarkIcon,
  DocumentIcon,
  DocumentChartBarIcon,
  PaperClipIcon,
  EllipsisVerticalIcon
} from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { getBalances, getAlerts } from '../services/api_dipendenti'
import { Link, useLocation } from "wouter";
import { Disclosure } from '@headlessui/react'
import { PlusIcon, ChevronDownIcon, InformationCircleIcon } from '@heroicons/react/20/solid'
import { DataContext } from '../contexts/data'
import UploadForm from '../components/upload_form'
import {years, months} from '../config'
import Navbar from '../components/navbar'
import CardCaricaBp from '../components/card_carica_bp'
import TourUtente from '../components/tour_utente'
import OpenTour from '../components/tour_utente'
// import { menuItems } from '../stores/menuData'
import { useAtom, useAtomValue } from 'jotai'
import { currentPageStore, firmePendingStore } from '../stores/mainStore'
import AvvisiComponent from './areariservata/avvisi'
import { checkSex, formatHoursFromMinutes } from '../utils'
import Fetching from '../components/fetching';
import Footer from '../components/footer';

const stats = [
  { label: 'Vacation days left', value: 12 },
  { label: 'Sick days left', value: 4 },
  { label: 'Personal days left', value: 2 },
]


const menuItems = [{
  icon: DocumentIcon,
  name: 'Buste Paga',
  href: '/areariservata/cedolini',
  iconForeground: 'text-indigo-800',
  iconBackground: 'bg-indigo-200',
  tourClass: 'tourBuste',
  isRapid: true,
  isEmployee: true,
  gestione: 'documenti'
},
  {
    icon: DocumentChartBarIcon,
    name: 'Certificazioni Uniche',
    href: '/areariservata/cu',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourCu',
    isRapid: true,
    isEmployee: true,
    gestione: 'documenti'
  },
  {
    icon: PaperClipIcon,
    name: 'Documenti',
    href: '/areariservata/documenti',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourDocumenti',
    isRapid: true,
    isEmployee: true,
    gestione: 'documenti'
  },]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function RootEmployee() {
  
  const { profile, token, isEmployee } = useContext(AuthContext)

  const [riepilogo, setRiepilogo] = useState([]);
  const [loadingRiepilogo, setLoadingRiepilogo] = useState(false);
  const [unreadAlertsCount, setUnreadAlertsCount] = useState(0);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  // Valorizzato dal layout (AuthLayout), che lo usa anche per il badge del menu
  const firmePending = useAtomValue(firmePendingStore);
  const [location, setLocation] = useLocation();

  const [currentPage, setCurrentPage] = useAtom(currentPageStore);

  const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");

  useEffect(() => {
    setCurrentPage('/')
    if (token) {
      fetchBalances();
      fetchAlerts();
      fetchNotifications();
    }
  }, [token])

  const fetchBalances = async () => {
    setLoadingRiepilogo(true)
    try {
      const response = await getBalances(token)
      setRiepilogo(response)
    } catch (error) {
      setLoadingRiepilogo(false)
      console.error(error)
    }
    setLoadingRiepilogo(false)
  };

  const fetchAlerts = async () => {
    const unreadCount = await getAlerts(token, { is_read: false, page: '', page_size: ''}, 'comunication');
    const count = unreadCount.count;
    setUnreadAlertsCount(count);   
  };

  const fetchNotifications = async () => {
    const unreadNotificationsCount = await getAlerts(token, { is_read: false, page: '', page_size: ''}, 'notification');
    const countNotifications = unreadNotificationsCount.count;
    setUnreadNotificationsCount(countNotifications);   
  };

  return (
    <div className='flex flex-col min-h-screen'>
      <main className="flex-1 pb-8">
        <div className="bg-white shadow">
          <div className="px-4 sm:px-6 lg:mx-auto lg:max-w-6xl lg:px-8">
            <div className="py-6 md:flex md:items-center md:justify-between lg:border-t lg:border-gray-200">
              <div className="flex-1 flex align-top">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center">
                    <div>
                      <div className="flex items-center">
                        <h1 className="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:leading-9">
                          {checkSex(profile?.employee?.cf) === 'F' ? 'Benvenuta' : 'Benvenuto'}
                          , <span className="block sm:inline">{profile?.employee?.first_name + ' ' + profile?.employee?.last_name}</span>
                        </h1>
                      </div>
                      <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                        <dt className="sr-only">Azienda</dt>
                        <dd className="flex items-center text-sm font-medium capitalize text-gray-500 sm:mr-6">
                          <svg className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 16.5v-13h-.25a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5H16v13h.25a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-3.5a.75.75 0 010-1.5H4zm3-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM7.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z" clipRule="evenodd"></path>
                          </svg>
                          {profile?.company?.name}
                        </dd>
                        <dt className="sr-only">Account status</dt>
                        <dd className="mt-3 flex items-center text-sm font-medium capitalize text-gray-500 sm:mr-6 sm:mt-0">
                          <svg className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd"></path>
                          </svg>
                          {profile?.employee?.cf}
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <Menu as="div" className="relative">
                    <div>
                      {profile.level[Object.keys(profile.level)[0]].includes("alerts") && (
                        <Menu.Button className="w-7 h-7 mt-2 text-gray-500 cursor-pointer">
                          <BellIcon className="w-8 h-8 text-gray-500" />
                          {unreadAlertsCount + unreadNotificationsCount > 0 && (
                            <span className="absolute top-0 left-4 flex items-center justify-center h-4 w-4 rounded-full ring-2 ring-white bg-red-500 text-white text-xs font-bold">
                              {unreadAlertsCount + unreadNotificationsCount}
                            </span>
                          )}
                        </Menu.Button>
                      )}
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform scale-95 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-95 opacity-0"
                    >
                      <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                        <div className="py-1">
                          {unreadAlertsCount > 0 ? (
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  onClick={() => setLocation(`/areariservata/avvisi/?type=Comunicazioni`)}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100 hover:font-semibold cursor-pointer'
                                  )}
                                >
                                  Hai {unreadAlertsCount} {unreadAlertsCount === 1 ? 'comunicazione' : 'comunicazioni'} da leggere
                                </span>
                              )}
                            </Menu.Item>
                          ) : (
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700'
                                  )}
                                >
                                  Nessun avviso
                                </span>
                              )}
                            </Menu.Item>
                          )}

                          {unreadNotificationsCount > 0 ? (
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  onClick={() => setLocation(`/areariservata/avvisi/?type=Notifiche`)}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100 hover:font-semibold cursor-pointer'
                                  )}
                                >
                                  Hai {unreadNotificationsCount} {unreadNotificationsCount === 1 ? 'notifica' : 'notifiche'} da leggere
                                </span>
                              )}
                            </Menu.Item>
                          ) : (
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700'
                                  )}
                                >
                                  Nessuna notifica
                                </span>
                              )}
                            </Menu.Item>
                          )}
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>

            </div>
          </div>
        </div>

        {firmePending > 0 && (
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mt-6">
            <Link
              to="/areariservata/documenti?tab=firmati"
              className="flex items-center justify-between rounded-lg border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm text-yellow-900 hover:bg-yellow-100"
            >
              <span>
                {firmePending === 1
                  ? 'Hai 1 documento in attesa della tua firma'
                  : `Hai ${firmePending} documenti in attesa della tua firma`}
              </span>
              <span className="font-semibold">Vai ai documenti →</span>
            </Link>
          </div>
        )}

        <div className="mt-8">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <h2 className="text-lg font-medium leading-6 text-gray-900">Collegamenti Rapidi</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-2">
              {menuItems.map((action) => {
                if (action.isEmployee) {
                  return (
                    <Link key={action.href} to={`${action.href}`} className="text-gray-900 font-medium hover:text-gray-600 flex w-full">
                    <div  className="bg-white shadow rounded p-6 flex flex-col items-center">
                      <div className={classNames(
                            action.iconBackground, "bg-green-500 p-4 rounded-full mb-4")}>
                        <action.icon className={classNames(action.iconForeground, "h-10 w-10")} />
                      </div>
                      <h2 className="text-xl font-semibold text-gray-800">{action.name}</h2>
                    </div>
                    </Link>
              )}
                return null
              })}
              </div>
          </div>

          {
            // two columns
          }

          {hasConsultalaHRPro && (
            <div className="mt-8">
              <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <h2 className="text-lg font-medium leading-6 text-gray-900">Riepilogo</h2>
                <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-6">
                  {
                    loadingRiepilogo && (
                      <Fetching />
                    )
                  }
                  {(!loadingRiepilogo && riepilogo.length > 0) ? 
                    (riepilogo.map((stat, index) => (
                        <div key={index} className="bg-white shadow overflow-hidden rounded-lg">
                          <div className="px-4 py-5 sm:p-6">
                            <dt className="text-sm font-small text-gray-500 truncate">{stat.rateo.name}</dt>
                            <dd className="mt-1 text-xl font-semibold text-gray-900">
                              <span>{formatHoursFromMinutes(stat.value)} ore</span>
                              <br />
                              <small className='text-xs font-small font-light text-gray-400'>
                                Ultimo aggiornamento: {moment(stat.updated_at).format('DD/MM/YYYY HH:mm')}
                              </small>
                            </dd>
                          </div>
                        </div>
                      ))
                    ) : (
                        <div className="bg-white shadow overflow-hidden rounded-lg">
                          <div className="px-4 py-5 sm:p-6">
                            <dt className="text-sm font-small text-gray-500 truncate"></dt>
                            <dd className="mt-1 text-xl font-semibold text-gray-900">
                              <small className='text-xs font-small font-light text-gray-400'>
                                Nessun rateo attivo
                              </small>
                            </dd>
                          </div>
                        </div>
                      )
                    }
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  )
}
